import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Directive({
	selector: 'report-builder-starter-ng'
})
export class ReportBuilderStarterDirective extends UpgradeComponent {
	@Input() primeNgNewReportDialog!: DynamicDialogRef;
	
	constructor(elementRef: ElementRef, injector: Injector) {
		super('reportBuilderStarter', elementRef, injector);
	}
}